<mat-card class="mat-elevation-z8 wp-overall">
  @if (loading()) {
    <div class="spinner-element">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }

  <mat-card-title>
    <div class="wp-overall__title">
      <div class="wp-overall__title-text">{{ title() }}</div>
      @if (showEditActions()) {
        <span class="wp-overall__actions">
          @if (!editMode()) {
            <button
              data-id="editWageringProfileOverall"
              mat-icon-button
              color="accent"
              (click)="startEditing()"
              matTooltip="Edit">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (editMode()) {
            <button
              data-id="saveWageringProfileOverall"
              mat-mini-fab
              color="accent"
              (click)="save()"
              matTooltip="Save changes">
              <mat-icon>save</mat-icon>
            </button>
            <button
              data-id="cancelWageringProfileOverall"
              mat-icon-button
              color="warn"
              (click)="cancelEditing()"
              matTooltip="Cancel">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </span>
      }
    </div>
    <mat-divider></mat-divider>
  </mat-card-title>

  <mat-card-content>
    <section class="wp-overall__scalars">
      <mat-form-field appearance="outline" class="wp-overall__field">
        <mat-label>Name</mat-label>
        <input
          matInput
          data-id="wageringProfileName"
          [ngModel]="details().name"
          (ngModelChange)="onNameChange($event)"
          [disabled]="!editMode()" />
      </mat-form-field>

      <div class="wp-overall__exclusive">
        <mat-checkbox
          data-id="wageringProfileExclusive"
          [checked]="details().exclusive"
          (change)="onExclusiveChange($event.checked)"
          [disabled]="!editMode()">
          Exclusive
        </mat-checkbox>
      </div>

      <div class="wp-overall__dates">
        <div class="wp-overall__date">
          <span class="wp-overall__date-label">Date created</span>
          <span class="wp-overall__date-value">{{
            details().dateCreated ? (details().dateCreated | date: 'dd-MM-yyyy HH:mm:ss') : '—'
          }}</span>
        </div>
        <div class="wp-overall__date">
          <span class="wp-overall__date-label">Date updated</span>
          <span class="wp-overall__date-value">{{
            details().dateUpdated ? (details().dateUpdated | date: 'dd-MM-yyyy HH:mm:ss') : '—'
          }}</span>
        </div>
      </div>
    </section>

    <section class="wp-overall__section">
      <div class="wp-overall__section-header">
        <h3 class="wp-overall__section-title">Groups</h3>
        @if (editMode()) {
          <button
            mat-stroked-button
            color="accent"
            type="button"
            data-id="wageringProfileAddGroup"
            (click)="addGroup()">
            <mat-icon>add</mat-icon>
            Add group
          </button>
        }
      </div>
      <div class="wp-overall__table-wrap">
        <table mat-table [dataSource]="groupsDataSource" class="wp-overall__table">
          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef>Group</th>
            <td mat-cell *matCellDef="let row">
              @if (editMode()) {
                <button
                  type="button"
                  class="wp-overall__group-pick"
                  data-id="wageringProfilePickGroup"
                  (click)="pickGroup(row)">
                  <span>{{ row.group?.label || row.group?.id || 'Select group…' }}</span>
                  <mat-icon>search</mat-icon>
                </button>
              } @else {
                {{ row.group?.label || row.group?.id }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="club">
            <th mat-header-cell *matHeaderCellDef>Club %</th>
            <td mat-cell *matCellDef="let row">
              @if (editMode()) {
                <input
                  class="wp-overall__cell-input"
                  type="number"
                  [ngModel]="row.club"
                  (ngModelChange)="onGroupFieldChange(row, 'club', $event)" />
              } @else {
                {{ row.club }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="bronze">
            <th mat-header-cell *matHeaderCellDef>Bronze %</th>
            <td mat-cell *matCellDef="let row">
              @if (editMode()) {
                <input
                  class="wp-overall__cell-input"
                  type="number"
                  [ngModel]="row.bronze"
                  (ngModelChange)="onGroupFieldChange(row, 'bronze', $event)" />
              } @else {
                {{ row.bronze }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="silver">
            <th mat-header-cell *matHeaderCellDef>Silver %</th>
            <td mat-cell *matCellDef="let row">
              @if (editMode()) {
                <input
                  class="wp-overall__cell-input"
                  type="number"
                  [ngModel]="row.silver"
                  (ngModelChange)="onGroupFieldChange(row, 'silver', $event)" />
              } @else {
                {{ row.silver }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="gold">
            <th mat-header-cell *matHeaderCellDef>Gold %</th>
            <td mat-cell *matCellDef="let row">
              @if (editMode()) {
                <input
                  class="wp-overall__cell-input"
                  type="number"
                  [ngModel]="row.gold"
                  (ngModelChange)="onGroupFieldChange(row, 'gold', $event)" />
              } @else {
                {{ row.gold }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="platinum">
            <th mat-header-cell *matHeaderCellDef>Platinum %</th>
            <td mat-cell *matCellDef="let row">
              @if (editMode()) {
                <input
                  class="wp-overall__cell-input"
                  type="number"
                  [ngModel]="row.platinum"
                  (ngModelChange)="onGroupFieldChange(row, 'platinum', $event)" />
              } @else {
                {{ row.platinum }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button
                mat-icon-button
                color="warn"
                type="button"
                matTooltip="Remove"
                data-id="wageringProfileRemoveGroup"
                (click)="removeGroup(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="groupColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: groupColumns()"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell wp-overall__empty" [attr.colspan]="groupColumns().length">No groups</td>
          </tr>
        </table>
      </div>
    </section>

    <section class="wp-overall__game-lists">
      <app-wagering-profile-game-list
        title="Include / exclude"
        listKey="games"
        [rows]="details().games.games"
        [editMode]="editMode()"
        (add)="addGame('games')"
        (remove)="removeGame('games', $event)">
      </app-wagering-profile-game-list>

      <app-wagering-profile-game-list
        title="Disabled games"
        listKey="disabledGames"
        [rows]="details().disabledGames.games"
        [editMode]="editMode()"
        (add)="addGame('disabledGames')"
        (remove)="removeGame('disabledGames', $event)">
      </app-wagering-profile-game-list>

      <app-wagering-profile-game-list
        title="Cash only"
        listKey="bonusExclude"
        [rows]="details().bonusExclude.games"
        [editMode]="editMode()"
        (add)="addGame('bonusExclude')"
        (remove)="removeGame('bonusExclude', $event)">
      </app-wagering-profile-game-list>
    </section>
  </mat-card-content>
</mat-card>
